import AddTagScreen from "../modules/tags/AddTagScreen";

export default function AddTag() {
  return (
    <>
      <AddTagScreen />
    </>
  )
}
